<div class="work-restrictions-rules">
  <app-loader *ngIf="isSaving"></app-loader>

  <!-- Toast уведомление -->
  <div class="work-restrictions-rules__toast" *ngIf="successMessage">
    <div class="work-restrictions-rules__toast-content">
      <span class="work-restrictions-rules__toast-icon">✓</span>
      {{ successMessage }}
    </div>
  </div>
  <div class="work-restrictions-rules__filters">
    <div class="work-restrictions-rules__filter">
      <div class="work-restrictions-rules__label">Район</div>
      <app-select
        [items]="districts"
        [initBy]="selectedDistrict"
        [textKey]="'name'"
        [defaultText]="'Название района'"
        [nullChoice]="true"
        (callback)="selectedDistrict = $event"
      ></app-select>
    </div>

    <div class="work-restrictions-rules__filter">
      <div class="work-restrictions-rules__label">Тип работ</div>
      <app-select
        [items]="workTypes"
        [initBy]="selectedWorkType"
        [textKey]="'name'"
        [defaultText]="'Тип работ'"
        [nullChoice]="true"
        (callback)="selectedWorkType = $event"
      ></app-select>
    </div>

    <div class="work-restrictions-rules__filter">
      <div class="work-restrictions-rules__label">Тип правила</div>
      <app-select
        [items]="ruleTypes"
        [initBy]="selectedRuleType"
        [textKey]="'name'"
        [defaultText]="'Тип правила'"
        [nullChoice]="true"
        (callback)="selectedRuleType = $event"
      ></app-select>
    </div>

    <div class="work-restrictions-rules__filter">
      <div class="work-restrictions-rules__label">Статус</div>
      <app-select [items]="statuses" [initBy]="selectedStatus" [textKey]="'name'" [defaultText]="'Статус'" [nullChoice]="true" (callback)="selectedStatus = $event"></app-select>
    </div>

    <div class="work-restrictions-rules__actions">
      <button type="button" class="button" (click)="onApply()">Применить</button>
      <button type="button" class="ctrl link link--dotted-gray-dark" (click)="onReset()">Сбросить</button>
      <button type="button" class="button work-restrictions-rules__create" (click)="onCreateRule()">Создать правило</button>
    </div>
  </div>

  <div class="work-restrictions-rules__groups">
    <!-- Индикатор загрузки -->
    <div class="work-restrictions-rules__loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <span>Загрузка правил...</span>
    </div>

    <!-- Ошибка загрузки -->
    <div class="work-restrictions-rules__error" *ngIf="error && !isLoading">
      <app-icon [glyph]="'hd-warning'" [size]="'24'"></app-icon>
      <span>{{ error }}</span>
    </div>

    <!-- Список групп -->
    <ng-container *ngIf="!isLoading && !error">
      <div class="work-restrictions-rules__empty" *ngIf="groups.length === 0">Правила ограничений не найдены</div>
      <div class="work-restrictions-rules__group" *ngFor="let group of groups">
        <!-- <button type="button" class="ctrl work-restrictions-rules__group-header" (click)="toggleGroup(group)">
        <span class="work-restrictions-rules__chevron" [class.work-restrictions-rules__chevron--collapsed]="group.collapsed">
          <span class="work-restrictions-rules__chevron-icon"></span>
        </span>
        <span class="work-restrictions-rules__group-count">({{ group.rules.length }})</span>
        <span class="work-restrictions-rules__group-title">{{ group.title }}</span>
      </button> -->

        <!-- Временно: только отображение сектора + количества записей (без клика). Функционал выше НЕ удаляем. -->
        <div class="work-restrictions-rules__group-header">
          <span class="work-restrictions-rules__group-count">({{ group.rules.length }})</span>
          <span class="work-restrictions-rules__group-title">{{ group.title }}</span>
        </div>

        <div class="work-restrictions-rules__table" [hidden]="group.collapsed">
          <div class="tbl">
            <div class="tbl__inner">
              <table class="work-restrictions-rules-table">
                <thead class="work-restrictions-rules-table__header">
                  <tr>
                    <th class="work-restrictions-rules-table__th">Район</th>
                    <th class="work-restrictions-rules-table__th">Тип работ</th>
                    <th class="work-restrictions-rules-table__th">Дни недели</th>
                    <th class="work-restrictions-rules-table__th">Интервал ограничения</th>
                    <th class="work-restrictions-rules-table__th">Тип правила</th>
                    <th class="work-restrictions-rules-table__th">Срок действия</th>
                    <th class="work-restrictions-rules-table__th">Статус</th>
                  </tr>
                </thead>
                <tbody class="work-restrictions-rules-table__body">
                  <tr *ngFor="let rule of group.rules" class="work-restrictions-rules-table__tr work-restrictions-rules-table__tr--clickable" (click)="onEditRule(rule, group)">
                    <td class="work-restrictions-rules-table__td">{{ rule.district }}</td>
                    <td class="work-restrictions-rules-table__td">{{ rule.workType }}</td>
                    <td class="work-restrictions-rules-table__td">{{ rule.weekDays }}</td>
                    <td class="work-restrictions-rules-table__td">{{ rule.timeInterval }}</td>
                    <td class="work-restrictions-rules-table__td">{{ rule.ruleType }}</td>
                    <td class="work-restrictions-rules-table__td">{{ rule.validity }}</td>
                    <td class="work-restrictions-rules-table__td">{{ rule.status }}</td>
                  </tr>
                  <tr *ngIf="group.rules.length === 0">
                    <td class="work-restrictions-rules-table__td work-restrictions-rules-table__td--empty" colspan="7">Нет данных</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
